import { Link } from 'react-router-dom';
import { SUPPORT_EMAIL, LAST_UPDATED } from '../legalInfo';
import '../pages/pages.css';

export default function LegalPage({ title, subtitle, sections }) {
  return (
    <div className="legal-page">
      <header className="legal-hero">
        <span className="legal-badge">Legal</span>
        <h1 className="legal-title">{title}</h1>
        {subtitle && <p className="legal-sub">{subtitle}</p>}
        <p className="legal-date">Last updated {LAST_UPDATED}</p>
      </header>

      <nav className="legal-toc" aria-label="Contents">
        <h2 className="legal-toc-title">Contents</h2>
        <ol>
          {sections.map((s) => (
            <li key={s.id}>
              <a href={`#${s.id}`}>{s.heading}</a>
            </li>
          ))}
        </ol>
      </nav>

      <div className="legal-body">
        {sections.map((s, i) => (
          <section key={s.id} id={s.id} className="legal-section">
            <h2>{i + 1}. {s.heading}</h2>
            {s.body}
          </section>
        ))}
      </div>

      <footer className="legal-foot">
        Questions about this page? Email{' '}
        <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a> or use our{' '}
        <Link to="/contact">contact form</Link>.
      </footer>
    </div>
  );
}
